// extracted by mini-css-extract-plugin
module.exports = {"app":"app-7a861b25"};